// extracted by mini-css-extract-plugin
export var coverWrapper = "VideoPlayer-module--coverWrapper--2a7d7";
export var imgWrapper = "VideoPlayer-module--imgWrapper--85c65";
export var loadingSpinner = "VideoPlayer-module--loadingSpinner--a34bf";
export var playBtnWrapper = "VideoPlayer-module--playBtnWrapper--da071";
export var show = "VideoPlayer-module--show--ab6f9";